var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4268 28.9868C24.1602 28.9602 23.8402 28.9602 23.5468 28.9868C17.2002 28.7735 12.1602 23.5735 12.1602 17.1735C12.1602 10.6402 17.4402 5.3335 24.0002 5.3335C30.5335 5.3335 35.8402 10.6402 35.8402 17.1735C35.8135 23.5735 30.7735 28.7735 24.4268 28.9868Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 10.6665C48.9333 10.6665 53.0933 14.8532 53.0933 19.9998C53.0933 25.0398 49.0933 29.1465 44.1067 29.3332C43.8933 29.3065 43.6533 29.3065 43.4133 29.3332",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0932 38.8265C4.63984 43.1465 4.63984 50.1865 11.0932 54.4798C18.4265 59.3865 30.4532 59.3865 37.7865 54.4798C44.2398 50.1598 44.2398 43.1198 37.7865 38.8265C30.4798 33.9465 18.4532 33.9465 11.0932 38.8265Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.907 53.3335C50.827 52.9335 52.6403 52.1602 54.1336 51.0135C58.2936 47.8935 58.2936 42.7468 54.1336 39.6268C52.667 38.5068 50.8803 37.7602 48.987 37.3335",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.fea5e6a5d47cf0fffb0930654091619a.svg";
export { ForwardRef as ReactComponent };